import { lazy, Suspense } from 'react'

import { LoadingTurbo } from 'atoms'

import { HourlyScreenComponent } from './HourlyScreen.types'
import { useHourlyScreen } from './useHourlyScreen'

const HourlyScreenDesktop = lazy(() => import('./HourlyScreen.desktop'))

const HourlyScreenMobile = lazy(() => import('./HourlyScreen.mobile'))

export const HourlyScreen: HourlyScreenComponent = ({ navigation, route }) => {
  const props = useHourlyScreen({ navigation, route })

  const Screen = props.isMobile ? HourlyScreenMobile : HourlyScreenDesktop

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Screen {...props} />
    </Suspense>
  )
}
